<template>
  <el-form size="small" ref="formData" :model="formData" label-width="120px" :rules="rules">
    <el-form-item label="URL">
      <el-input v-model="formData.dwn_url"></el-input>
    </el-form-item>
    <el-form-item label="EN Name">
      <el-input v-model="formData.dwn_en_name"></el-input>
    </el-form-item>
    <el-form-item label="ES Name">
      <el-input v-model="formData.dwn_es_name"></el-input>
    </el-form-item>
    <el-form-item align="right">
      <el-button @click="$emit('closeDialog')">back</el-button>
      <el-button class="el-button--primary" @click="submit('formData')">save</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'WhiteNoiseUpdate',
    props:{
      chooseItem:Object,
      closeDialog:Function,
      dialogSucc:Function
    },
    data(){
      return{
        formData:{
          dwn_url:'',
          dwn_en_name:'',
          dwn_es_name:'',
          dwn_id:'',
        },
        rules:{

        }
      }
    },
    created () {
      this.getData()
    },
    methods:{
      getData(){
        this.formData=JSON.parse(JSON.stringify(this.chooseItem))
      },
      submit(formName){
        this.$refs[formName].validate(
          (valid)=>{
            if(valid){
              let loading=this.$util.loading()
              this.$api.rootV1.post('/web/whitenoise/editor', this.formData,
                (res) => {
                  this.$alert( 'update successfully!','info', {
                    confirmButtonText: 'confirm',
                    type:'success',
                    callback: action => {
                      loading.close()
                      this.$emit("dialogSucc")
                    }
                  })
                }, (res) => {
                  this.$alert( `update failed!${res.errmsg}`,'info', {
                    confirmButtonText: 'confirm',
                    type:'error',
                    callback: action => {
                      loading.close()
                      this.$emit("closeDialog")
                    }
                  })
                })
            }else {
              this.$message.warning('Please check the input data!')
            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/whitenoise/WhiteNoiseUpdate.vue